/* eslint-disable react/prop-types */
import React, { useMemo } from "react";
import {
  Box,
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import SportsSoccerOutlinedIcon from '@mui/icons-material/SportsSoccerOutlined';
import VideogameAssetOutlinedIcon from '@mui/icons-material/VideogameAssetOutlined';
import MusicNoteOutlinedIcon from '@mui/icons-material/MusicNoteOutlined';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import TheaterComedyOutlinedIcon from '@mui/icons-material/TheaterComedyOutlined';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import en from '../../nls/en.json';
import { OptionsWrapper, theme } from "../Styles/AfterSchoolStyle";
import { isEmpty } from "../../utils/constants";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const MentorAfterSchool = ({ getAfterSchool, data }) => {
  
  const dataArray = data?.data?.ACADEMIC_BACKGROUND?.find(item => item?.sub_category_name === "LIKE_TO_DO_AFTER_SCHOOL");
  const location = useLocation();
  const mentorId = location?.state?.mentorId;
  const { savedAnswer, studentProfileIfo } = useSelector(({ studentInfoSlice }) => studentInfoSlice);
  const { ACADEMIC_BACKGROUND  } = mentorId ? studentProfileIfo : savedAnswer;
  const { BASIC_INFORMATION } = savedAnswer;
  const defaultvals =  !isEmpty(ACADEMIC_BACKGROUND) && ACADEMIC_BACKGROUND?.find(item => item.sub_category_name === "LIKE_TO_DO_AFTER_SCHOOL")?.options?.map(option => option?.option_id) || [];
  const [activityCheckBox, setactivityCheckBox] = React.useState(defaultvals);
  const handleCheckboxChange = (option) => {
    if (activityCheckBox.includes(option.option_id)) {
      setactivityCheckBox((prev) => prev.filter((id) => id !== option.option_id));
    } else {
      if (activityCheckBox.length < 3) {
        setactivityCheckBox((prev) => [...prev, option.option_id]);
      }
    }
  };

  const changeColor = {
    fill: '#fff'
  };

  const iconMapping = {
    
    "MAJOR_CATEGORIES_STEM_CLUBS": <svg xmlns="http://www.w3.org/2000/svg" width="17.467" height="17.508" viewBox="0 0 17.467 17.508">
    <path style={activityCheckBox.includes('MAJOR_CATEGORIES_STEM_CLUBS') ? changeColor : null} id="manufacturing_FILL0_wght400_GRAD0_opsz24" d="M83.21-871.663l-.25-1.251q-.25-.1-.469-.219a3.63,3.63,0,0,1-.448-.281l-1.209.375L80-874.456l.959-.834a3.56,3.56,0,0,1-.042-.542,3.557,3.557,0,0,1,.042-.542L80-877.207l.834-1.417,1.209.375a3.628,3.628,0,0,1,.448-.281q.219-.115.469-.219L83.21-880h1.667l.25,1.251q.25.1.469.219a3.629,3.629,0,0,1,.448.281l1.209-.375.834,1.417-.959.834a3.557,3.557,0,0,1,.042.542,3.559,3.559,0,0,1-.042.542l.959.834-.834,1.417-1.209-.375a3.63,3.63,0,0,1-.448.281q-.219.115-.469.219l-.25,1.251Zm.834-2.5a1.606,1.606,0,0,0,1.178-.49,1.606,1.606,0,0,0,.49-1.178,1.606,1.606,0,0,0-.49-1.178,1.606,1.606,0,0,0-1.178-.49,1.606,1.606,0,0,0-1.178.49,1.606,1.606,0,0,0-.49,1.178,1.606,1.606,0,0,0,.49,1.178A1.606,1.606,0,0,0,84.044-874.164Zm6.628,11.672-.375-1.751a3.778,3.778,0,0,1-.657-.3,5.3,5.3,0,0,1-.594-.406l-1.667.542-1.167-2,1.334-1.167a6.792,6.792,0,0,1-.042-.75,6.792,6.792,0,0,1,.042-.75l-1.334-1.167,1.167-2,1.667.542a5.313,5.313,0,0,1,.594-.406,3.783,3.783,0,0,1,.657-.3l.375-1.751h2.334l.375,1.751a3.782,3.782,0,0,1,.657.3,5.313,5.313,0,0,1,.594.406l1.667-.542,1.167,2-1.334,1.167a6.792,6.792,0,0,1,.042.75,6.792,6.792,0,0,1-.042.75l1.334,1.167-1.167,2-1.667-.542a5.3,5.3,0,0,1-.594.406,3.778,3.778,0,0,1-.657.3l-.375,1.751Zm1.167-3.335a2.412,2.412,0,0,0,1.772-.729,2.412,2.412,0,0,0,.73-1.772,2.412,2.412,0,0,0-.73-1.772,2.412,2.412,0,0,0-1.772-.729,2.412,2.412,0,0,0-1.772.729,2.412,2.412,0,0,0-.73,1.772,2.412,2.412,0,0,0,.73,1.772A2.412,2.412,0,0,0,91.839-865.826Z" transform="translate(-80 880)" fill="#1468a2"/>
    </svg>,
    "MAJOR_CATEGORIES_SPORT": <SportsSoccerOutlinedIcon fontSize="small" sx={{ mr: 1 }} />,
    "MAJOR_CATEGORIES_MUSIC": <MusicNoteOutlinedIcon fontSize="small" sx={{ mr: 1 }} />,
    "MAJOR_CATEGORIES_DANCE": <svg xmlns="http://www.w3.org/2000/svg" width="13.834" height="25.143" viewBox="0 0 13.834 25.143">
    <path style={activityCheckBox.includes('MAJOR_CATEGORIES_DANCE') ? changeColor : null} id="Union_164" data-name="Union 164" d="M477.518-2649.856l-5.593-5.863-1.6,5.863h-2.057l2.019-7.38c-2.277-1.8-1.857-5.078-1.857-5.078a4.625,4.625,0,0,1,.183-1.193l.892-2.146L467-2675h2.009l2.068,7.725,2.425,1.006.016-.026.141.09.01,0v0l7.166,4.577-1,1.571-6.259-4-1.172,2.823a3.55,3.55,0,0,1,.554,2.863l1.6,2.393,5.83,6.114,0,0Zm-5.849-19.165a2.088,2.088,0,0,1,2.089-2.088,2.088,2.088,0,0,1,2.088,2.088,2.089,2.089,0,0,1-2.088,2.089A2.089,2.089,0,0,1,471.669-2669.021Z" transform="translate(-467 2675)" fill="#1468a2"/>
    </svg>,
    "MAJOR_CATEGORIES_SOCIAL_ACTIVISM": <HandshakeOutlinedIcon fontSize="small" sx={{ mr: 1 }} />,
    "MAJOR_CATEGORIES_THEATRE": <TheaterComedyOutlinedIcon fontSize="small" sx={{ mr: 1 }} />,
    "MAJOR_CATEGORIES_WRITING_JOURNALISM": <EditNoteOutlinedIcon fontSize="small" sx={{ mr: 1 }} />,
    "MAJOR_CATEGORIES_VIDEO_GAMES": <VideogameAssetOutlinedIcon fontSize="small" sx={{ mr: 1 }} />,
  };

  useMemo(()=>{
    getAfterSchool(activityCheckBox);
   },[activityCheckBox])

  return (
    <ThemeProvider theme={theme}>
      <Box>
        <Box variant="form">
          {
            // !isFromEdit &&
          <Typography variant="h2">{en?.AFTERSCHOOL_TITLE}</Typography>
          }
          <OptionsWrapper>
            <Typography variant="h3" sx={{ mb: 0 }}>
              {dataArray?.question_text} <span style={{color: "#DC3545" }}>*</span>
            </Typography>
             {BASIC_INFORMATION?.role_name === 'Mentor' ? null : 
            <Typography
              variant="body2"
              sx={{ fontSize: "12px", color: "#666666" }}
            >
              (Please select up to 3)
            </Typography>
            }
            <FormGroup sx={{ mt: 2 }}>
              {dataArray?.options?.map((option) => (
                <FormControlLabel
                  key={option?.option_id}
                  control={
                    <Checkbox
                      checked={activityCheckBox.includes(option.option_id)}
                      onChange={() => handleCheckboxChange(option)}
                    />
                  }
                  label={
                    <React.Fragment>
                      {iconMapping[option?.option_key]}
                      {option?.option_text}
                    </React.Fragment>
                  }
                />
              ))}
            </FormGroup>
          </OptionsWrapper>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default MentorAfterSchool;
